import { postcodeValidatorExistsForCountry } from "postcode-validator";

export const isZipValidationAvailable = (countryIsoCode: string): boolean => {
  return postcodeValidatorExistsForCountry(countryIsoCode?.toUpperCase()) || false;
};
